import { configureStore } from '@reduxjs/toolkit'
import user_information from "../Redux/user_information"

export default configureStore({
  reducer: {
    user:user_information,
  },
})